import React, { Component } from 'react';
import './BarChart.css';
import { d3 } from 'react-d3-components';

class BarChart extends Component {
  componentDidMount() {
    this.buildGraph();
  }

  componentWillReceiveProps(props) {
    this.updateGraph(props.data);
  }

  buildGraph() {
    const {
      data = [],
      width = this.barChartSpace.offsetWidth,
      height = 300,
      yAxisTitle,
      barLine,
    } = this.props;

    const margin = {
      bottom: 80,
      left: 40,
      right: 70,
      top: 20,
    };

    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    const x = d3.scale.ordinal().rangeRoundBands([30, chartWidth], 0.5)
      .domain(data.map((d) => d.x));

    const y = d3.scale.linear()
      .range([chartHeight, 0])
      .domain([0,
        d3.max(data, d => d.y)]);

    const xAxis = d3.svg.axis().scale(x).orient('bottom')
      .innerTickSize(-chartHeight)
      .outerTickSize(0)
      .tickPadding(10);

    const yAxis = d3.svg.axis().scale(y).orient('left')
      .innerTickSize(-chartWidth)
      .outerTickSize(0)
      .tickPadding(10);

    const svg = d3.select(this.barChartSpace).append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`);
    this.setState({
      svg,
    }, () => {
      this.addAxes(xAxis, yAxis, margin, chartWidth, chartHeight, yAxisTitle);
      this.drawBars(x, y, data, barLine, chartHeight);
    });
  }

  addAxes(xAxis, yAxis, margin, chartWidth, chartHeight, yAxisTitle) {
    const { svg } = this.state;

    const axes = svg.append('g')
      .attr('class', 'axies');

    axes.append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0,${chartHeight})`)
      .call(xAxis)
      .selectAll('text')
      .attr('transform', 'rotate(25)')
      .style('text-anchor', 'start')
      .append('text')
      .attr('y', -6)
      .attr('x', chartWidth - margin.right)
      .style('text-anchor', 'middle')
      .text('Time');

    axes.append('g')
      .attr('class', 'y axis')
      .attr('transform', 'translate(30,0)')
      .call(yAxis)
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', -55)
      .attr('dy', '.71em')
      .style('text-anchor', 'end')
      .text(yAxisTitle);
  }

  drawBars(x, y, data, barLine, chartHeight) {
    const { svg } = this.state;

    const bars = svg.append('g')
      .attr('class', 'bars')
      .selectAll('.bar');

    bars.data(data)
      .enter()
      .append('rect')
      .attr('class', 'bar')
      .style('fill', barLine)
      .attr('x', (d) => x(d.x))
      .attr('width', x.rangeBand())
      .attr('y', (d) => y(d.y))
      .attr('height', (d) => chartHeight - y(d.y));

    bars.data(data)
      .enter()
      .append('text')
      .style('text-anchor', 'middle')
      .attr('x', (d) => x(d.x) + (x.rangeBand() / 2))
      .attr('y', (d) => y(d.y) - 6)
      .text((d) => `Count: ${d.y}, Range: ${d.min.toFixed(2)} - ${d.max.toFixed(2)}`);
  }

  updateGraph(data) {
    const {
      width = this.barChartSpace.offsetWidth,
      height = 300,
      barLine,
    } = this.props;

    const margin = {
      bottom: 80,
      left: 40,
      right: 70,
      top: 20,
    };

    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    const x = d3.scale.ordinal().rangeRoundBands([30, chartWidth], 0.5)
      .domain(data.map((d) => d.x));

    const y = d3.scale.linear()
      .range([chartHeight, 0])
      .domain([0,
        d3.max(data, d => d.y)]);

    const xAxis = d3.svg.axis().scale(x).orient('bottom')
      .innerTickSize(-chartHeight)
      .outerTickSize(0)
      .tickPadding(10);

    const yAxis = d3.svg.axis().scale(y).orient('left')
      .innerTickSize(-chartWidth)
      .outerTickSize(0)
      .tickPadding(10);

    this.updateBars(x, y, data, chartHeight, barLine);
    this.updateAxes(xAxis, yAxis, margin, chartWidth, chartHeight);
  }

  updateBars(x, y, data, chartHeight, barLine) {
    const { svg } = this.state;

    const bars = svg.select('.bars').selectAll('.bar').data(data);

    bars.exit().remove();

    bars.enter()
      .append('rect')
      .attr('class', 'bar')
      .style('fill', barLine)
      .attr('x', (d) => x(d.x))
      .attr('width', x.rangeBand())
      .attr('y', (d) => y(d.y))
      .attr('height', (d) => chartHeight - y(d.y));

    bars.transition()
      .duration(500)
      .attr('x', (d) => x(d.x))
      .attr('width', x.rangeBand())
      .attr('y', (d) => y(d.y))
      .attr('height', (d) => chartHeight - y(d.y));

    const texts = svg.select('.bars').selectAll('text').data(data);


    texts.exit().remove();

    texts.data(data)
      .enter()
      .append('text')
      .style('text-anchor', 'middle')
      .attr('x', (d) => x(d.x) + (x.rangeBand() / 2))
      .attr('y', (d) => y(d.y) - 6)
      .text((d) => `Count: ${d.y}, Range: ${d.min.toFixed(2)} - ${d.max.toFixed(2)}`);

    texts.transition()
      .duration(500)
      .attr('x', (d) => x(d.x) + (x.rangeBand() / 2))
      .attr('y', (d) => y(d.y) - 6)
      .text((d) => `Count: ${d.y}, Range: ${d.min.toFixed(2)} - ${d.max.toFixed(2)}`);
  }

  updateAxes(xAxis, yAxis) {
    const { svg } = this.state;

    const axes = svg.select('.axies');

    axes.select('.x.axis')
      .call(xAxis)
      .selectAll('text')
      .attr('transform', 'rotate(25)')
      .style('text-anchor', 'start');

    axes.select('.y.axis')
      .call(yAxis);
  }

  render() {
    return (
      <div className="barChartSpace"
        ref={(c) => { this.barChartSpace = c; }}
      />
    );
  }
}

export default BarChart;
